module.exports = __webpack_public_path__ + "img/Jakub.824ed7ce.png";